import React, { Component } from 'react';
import Button from '../../components/Button';
import Select from '../../components/Select';
import { Input, Checkbox} from '../../components/Input';
import './Form.css';
import { validate } from './Validate.js';
import { submit } from './Submit.js';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { loadInformation } from '../../actions/InformationActions';
import { HOST } from '../../constants/Fetch'
import requestAll from '../../actions/Common';
import { bindActionCreators } from 'redux';

class FormRecommendation extends Component {
  static requestData(store) {
    return requestAll([loadInformation], store);
  }
  componentDidMount() {
    this.props.actions.loadInformation();
  }

  state = {
    isValidated: false,
    showFormSuccess: false
  };

  handleSubmit = (event) => {
    event.preventDefault();
    if (validate(this.formEl)) {
      submit(null, false, event, this, this.props.apiUrl);
    }
    this.setState({ isValidated: true });
  }
  render() {
    const cityNames = [];
    if (this.props.cities) {
      for (let i = 0; i < this.props.cities.length; i++) {
        cityNames[i] = {
          label: this.props.cities[i].name,
          value: this.props.cities[i].id
        }
      }
    }

    return (
      <form
        noValidate
        ref={form => (this.formEl = form)}
        className={`form ${this.props.modifier ? this.props.modifier : '' } ${this.state.isValidated ? 'form--wasValidated' : ''}`}
        onSubmit={this.handleSubmit}
      >
        <h2 className="text text--h2">Ваш кандидат</h2>
        <div className="form__row row row--smallOffset">
          <div className="form__col col colVertTablet--12">
            <Select required name="city_candidate" options={cityNames} placeholder="Город" alphabeticSort={true} />
          </div>
          <div className="form__col col colVertTablet--12">
            <Input required id="form-mailCandidate" modifier="input--wide" label="Эл. почта" name="email_candidate" type="email" />
          </div>
        </div>
        <div className="form__row form__row--marginBottom row row--smallOffset">
          <div className="form__col col colVertTablet--12">
            <Input required id="form-nameCandidate" modifier="input--wide" label="Имя" name="last_name_candidate" />
          </div>
          <div className="form__col col colVertTablet--12">
            <Input required id="form-surnameCandidate" modifier="input--wide" label="Фамилия" name="first_name_candidate" />
          </div>
        </div>
        <h2 className="text text--h2">Расскажите о себе</h2>
        <div className="form__row row row--smallOffset">
          <div className="form__col col colVertTablet--12">
            <Select required name="city_author" options={cityNames} placeholder="Город" />
          </div>
          <div className="form__col col colVertTablet--12" />
        </div>
        <div className="form__row row row--smallOffset">
          <div className="form__col col colVertTablet--12">
            <Input required id="form-name" modifier="input--wide" label="Имя" name="last_name_author" />
          </div>
          <div className="form__col col colVertTablet--12">
            <Input required id="form-surname" modifier="input--wide" label="Фамилия" name="first_name_author" />
          </div>
        </div>
        <div className="form__row row row--smallOffset">
          <div className="form__col col colVertTablet--12">
            <Input required id="form-phone" modifier="input--wide" label="Телефон" name="phone_author" type="phone" />
          </div>
          <div className="form__col col colVertTablet--12">
            <Input required id="form-mail" modifier="input--wide" label="Эл. почта" name="email_author" type="email" />
          </div>
        </div>
        <div className="form__row form__row--marginTop row row--smallOffset">
          <div className="form__col col col--12">
            <Checkbox required modifier={this.props.modifier && this.props.modifier.indexOf('form--lighten') !== -1 && 'input--lighten'} label="Я подтверждаю, что рекомендуемый кандидат интересуется работой в Дом.ru и знает, что я его рекомендую." id="apply" checked={false} />
          </div>
          <div className="form__col col col--12">
            <Checkbox required modifier={this.props.modifier && this.props.modifier.indexOf('form--lighten') !== -1 && 'input--lighten'}  id="apply2" checked={false}>
              Я ознакомлен и согласен с <a href={HOST + this.props.information.personal_oferta} target="_blank">условиями сбора и обработки персональных данных</a>
            </Checkbox>
          </div>
        </div>
        <div className="form__receivedMsg"></div>
        <Button disabled={this.state.showFormSuccess && true} link="/" text="Отправить анкету" modifier="button--wide-mobile" submit />
      </form>
    );
  }
}

const mapStateToProps = (state) => {
  return {
      information: state.information.item
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({ loadInformation }, dispatch),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FormRecommendation));



// WEBPACK FOOTER //
// ./src/components/Form/FormRecommendation.js